import React from 'react';
import { Button } from '@codex/basics';
import { Icon } from '@codex/icons';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
  margin: -24px 0 -24px 4px;
  width: 24;
  height: 24;
`;
const StyledButton = styled(Button)`
  margin-bottom: 20px;
`;

const ButtonWithLoader = () => (
  <StyledButton disabled>
    <StyledIcon
      icon={'Spinner'}
      spin
    />
  </StyledButton>
);

export default ButtonWithLoader;
